import React from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import {
  DollarOutlined,
  ClockCircleOutlined,
  CheckOutlined,
} from '@ant-design/icons';

interface WithdrawalStatisticsProps {
  transactions: any[];
  formatCurrency: (amount: number) => string;
}

const WithdrawalStatistics: React.FC<WithdrawalStatisticsProps> = ({
  transactions,
  formatCurrency,
}) => {
  // Calculate statistics
  const pendingTransactions = transactions.filter(
    (t) => t.status === 'PENDING'
  );
  const completedTransactions = transactions.filter(
    (t) => t.status === 'COMPLETED'
  );
  const totalAmount = transactions.reduce((sum, t) => sum + t.balance, 0);
  const pendingAmount = pendingTransactions.reduce(
    (sum, t) => sum + t.balance,
    0
  );

  return (
    <Row gutter={16} className="mb-6">
      <Col span={6}>
        <Card size="small" className="bg-blue-50 border-blue-200">
          <Statistic
            title="Tổng giao dịch"
            value={transactions.length}
            prefix={<DollarOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card size="small" className="bg-orange-50 border-orange-200">
          <Statistic
            title="Chờ xác nhận"
            value={pendingTransactions.length}
            prefix={<ClockCircleOutlined />}
            valueStyle={{ color: '#fa8c16' }}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card size="small" className="bg-blue-50 border-blue-200">
          <Statistic
            title="Đã xác nhận"
            value={completedTransactions.length}
            prefix={<CheckOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card size="small" className="bg-purple-50 border-purple-200">
          <Statistic
            title="Tổng tiền chờ"
            value={pendingAmount}
            formatter={(value) => formatCurrency(Number(value))}
            valueStyle={{ color: '#722ed1' }}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default WithdrawalStatistics;
